import { render } from "./HeaderMegaMenu.vue?vue&type=template&id=0ed24892&scoped=true"
import script from "./HeaderMegaMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMegaMenu.vue?vue&type=script&lang=js"

import "./HeaderMegaMenu.vue?vue&type=style&index=0&id=0ed24892&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed24892"]])

export default __exports__